module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overflow-auto mb-16 px-2"
  }, [_c('div', [(_vm.courseWorkId) ? _c('div', {
    staticClass: "flex items-center bg-gray-50 px-5 py-2.5 mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "px-8 py-2 h-9 bg-red-400 rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    on: {
      "click": _vm.disconnectIntegration
    }
  }, [_vm._v("\n        Disconnect\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "font-semibold text-lg"
  }, [_vm._v("\n      " + _vm._s(_vm.header) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-center text-gray-500 text-sm"
  }, [_c('img', {
    staticClass: "mr-2 rounded-full",
    attrs: {
      "src": _vm.logo,
      "height": "25px",
      "width": "25px"
    }
  }), _vm._v(" "), (!_vm.edLink) ? _c('div', [_vm._v("\n        " + _vm._s(_vm.getCourseDetail.google_classroom_integration.course_name) + "\n      ")]) : _c('div', [_vm._v(_vm._s(_vm.integration.course_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "py-4"
  }, [(_vm.selected_tab === 'create_assignment_tab') ? [_c('div', {
    staticClass: "flex flex-col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "w-full px-4 py-2 mb-3 bg-input rounded text-gray-500",
    style: (_vm.title.trim().length === 0 ? 'border-color:red' : ''),
    attrs: {
      "placeholder": "Roundtable Name"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rounded text-md text-gray-500 focus-within:border-primary border border-solid border-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "resize-none w-full focus:outline-none bg-input overflow-auto px-4 py-2 rounded",
    attrs: {
      "placeholder": "Description",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex items-center bg-input rounded px-4 -mt-3 pb-3"
  }, [_c('i', {
    staticClass: "fa-solid text-lg mr-3 fa-circle-info"
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.link_to_RT_html)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row gap-3 mt-4"
  }, [(_vm.schoology_categories.length) ? _c('div', {
    staticClass: "flex flex-col w-6/12"
  }, [_c('span', {
    staticClass: "font-semibold"
  }, [_vm._v(" Assignment Category ")]), _vm._v(" "), _c('pl-select', {
    staticClass: "mt-2 bg-gray-50 rounded text-gray-500",
    attrs: {
      "options": _vm.schoology_categories,
      "selected": _vm.schoology_category,
      "label": "name",
      "arrow": true,
      "placeholder": "Select a category"
    },
    on: {
      "change": function($event) {
        _vm.schoology_category = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col justify-between"
  }, [_c('span', {
    staticClass: "font-semibold"
  }, [_vm._v(" Due Date ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 py-2 px-4 bg-input rounded border-0 outline-none"
  }, [_c('flat-pickr', {
    staticClass: "border-none bg-input border-0 border-input",
    attrs: {
      "config": _vm.config,
      "placeholder": "Select a date"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col w-2/12"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_vm._v("Max Score")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxPoints),
      expression: "maxPoints"
    }],
    staticClass: "mt-2 px-4 py-2 bg-input rounded text-sm text-gray-500 w-full",
    style: (_vm.max_points_error ? 'border-color:red' : ''),
    domProps: {
      "value": (_vm.maxPoints)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.maxPoints = $event.target.value
      }, _vm.inputed]
    }
  }), _vm._v(" "), (_vm.max_points_error) ? _c('span', {
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.max_points_error_message)
    }
  }) : _vm._e()])])])] : [(_vm.courseWorkId) ? [_c('div', {
    staticClass: "grid grid-cols-2 gap-x-3"
  }, [_c('div', {
    staticClass: "flex flex-col"
  }, [_c('p', {
    staticClass: "text-base text-black"
  }, [_vm._v("Available")]), _vm._v(" "), _c('div', {
    staticClass: "w-full h-80 p-3 border border-gray-100 rounded overflow-auto"
  }, [_c('div', {
    staticClass: "mb-2 bg-white border rounded border-gray-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_string_available),
      expression: "search_string_available"
    }],
    staticClass: "p-2 text-sm placeholder-gray-200 w-full text-gray-500 bg-input",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search_string_available)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_string_available = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.students_to_import.length) ? _c('div', {
    staticClass: "flex flex-nowrap"
  }, [_c('pl-checkbox', {
    attrs: {
      "disabled": _vm.remove_student_mode
    },
    on: {
      "change": function($event) {
        return _vm.handleSelectAllAvailable($event)
      }
    },
    model: {
      value: (_vm.is_all_selected_available),
      callback: function($$v) {
        _vm.is_all_selected_available = $$v
      },
      expression: "is_all_selected_available"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-gray-500"
  }, [_vm._v(_vm._s(_vm.is_all_selected_available ? 'De-select All' : 'Select All'))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.sorted_available_list), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "flex flex-nowrap my-2"
    }, [_c('pl-checkbox', {
      attrs: {
        "disabled": _vm.remove_student_mode
      },
      on: {
        "change": function($event) {
          return _vm.handleSelectStudent($event, user.id || user.userId)
        }
      },
      model: {
        value: (_vm.sorted_available_list[index].selected),
        callback: function($$v) {
          _vm.$set(_vm.sorted_available_list[index], "selected", $$v)
        },
        expression: "sorted_available_list[index].selected"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text-gray-500"
    }, [_vm._v(_vm._s(user.name || user.profile.name.fullName))])], 1)
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "px-8 py-2 mt-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": _vm.students_selected_for_invited.length === 0
    },
    on: {
      "click": function($event) {
        _vm.operation = 'invite';
        _vm.finish();
      }
    }
  }, [_vm._v("\n              Invite\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('p', {
    staticClass: "text-base text-black"
  }, [_vm._v("Invited")]), _vm._v(" "), (!_vm.remove_student_mode) ? _c('div', {
    staticClass: "w-full h-80 p-3 border border-gray-100 rounded overflow-auto"
  }, [_c('div', {
    staticClass: "mb-2 bg-white border rounded border-gray-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_string_invited),
      expression: "search_string_invited"
    }],
    staticClass: "p-2 text-sm placeholder-gray-200 w-full text-gray-500 bg-input",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search_string_invited)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_string_invited = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.can_be_removed.length) ? _c('div', {
    staticClass: "flex flex-nowrap"
  }, [_c('pl-checkbox', {
    attrs: {
      "checkBoxClass": "checkmark-red",
      "disabled": _vm.remove_student_mode
    },
    on: {
      "change": function($event) {
        return _vm.handleSelectAllInvited($event)
      }
    },
    model: {
      value: (_vm.is_all_selected_invited),
      callback: function($$v) {
        _vm.is_all_selected_invited = $$v
      },
      expression: "is_all_selected_invited"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n                  " + _vm._s(_vm.is_all_selected_invited ? 'De-select All' : 'Select All') + "\n                ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.sorted_invited_list), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "flex flex-nowrap my-2"
    }, [_c('pl-checkbox', {
      attrs: {
        "checkBoxClass": "checkmark-red",
        "disabled": _vm.remove_student_mode
      },
      on: {
        "change": function($event) {
          return _vm.handleSelectStudentUninvite(
            $event,
            user.id || user.userId
          )
        }
      },
      model: {
        value: (_vm.sorted_invited_list[index].selected),
        callback: function($$v) {
          _vm.$set(_vm.sorted_invited_list[index], "selected", $$v)
        },
        expression: "sorted_invited_list[index].selected"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text-gray-500"
    }, [_vm._v(_vm._s(user.name || user.profile.name.fullName))])], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "px-8 py-2 mt-2 bg-red-400 rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": _vm.students_selected_for_available.length === 0
    },
    on: {
      "click": function($event) {
        _vm.operation = 'remove';
        _vm.finish();
      }
    }
  }, [_vm._v("\n              Remove\n            ")])])])] : [_c('div', {
    staticClass: "flex m-0 w-full"
  }, [_c('div', {
    staticClass: "flex flex-col col-md-student w-full"
  }, [_c('p', {
    staticClass: "text-base text-black"
  }, [_vm._v("Available")]), _vm._v(" "), _c('div', {
    staticClass: "w-full h-80 max-h-80 p-3 border border-gray-100 rounded overflow-y-auto"
  }, [_c('div', {
    staticClass: "mb-2 bg-white border rounded border-gray-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_string_available),
      expression: "search_string_available"
    }],
    staticClass: "p-2 text-sm placeholder-gray-200 w-full text-gray-500 bg-input",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search_string_available)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_string_available = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.students_to_import.length) ? _c('div', {
    staticClass: "flex flex-nowrap"
  }, [_c('pl-checkbox', {
    attrs: {
      "disabled": _vm.remove_student_mode
    },
    on: {
      "change": function($event) {
        return _vm.handleSelectAllAvailable($event)
      }
    },
    model: {
      value: (_vm.is_all_selected_available),
      callback: function($$v) {
        _vm.is_all_selected_available = $$v
      },
      expression: "is_all_selected_available"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n                  " + _vm._s(_vm.is_all_selected_available ? 'De-select All' : 'Select All') + "\n                ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.sorted_available_list), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "flex flex-nowrap my-2"
    }, [_c('pl-checkbox', {
      attrs: {
        "disabled": _vm.remove_student_mode
      },
      on: {
        "change": function($event) {
          return _vm.handleSelectStudent($event, user.id || user.userId)
        }
      },
      model: {
        value: (_vm.sorted_available_list[index].selected),
        callback: function($$v) {
          _vm.$set(_vm.sorted_available_list[index], "selected", $$v)
        },
        expression: "sorted_available_list[index].selected"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text-gray-500"
    }, [_vm._v("\n                  " + _vm._s(user.name || user.profile.name.fullName) + "\n                ")])], 1)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col col-md-separator px-4 justify-center"
  }, [_c('button', {
    staticClass: "bg-gray-200 my-2 text-center cursor-pointer disabled:opacity-50",
    attrs: {
      "disabled": _vm.students_selected_for_invited.length === 0
    },
    on: {
      "click": _vm.moveToInvited
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right text-2xl text-gray-500"
  })]), _vm._v(" "), _c('button', {
    staticClass: "bg-gray-200 my-2 text-center cursor-pointer disabled:opacity-50",
    attrs: {
      "disabled": _vm.students_selected_for_available.length === 0
    },
    on: {
      "click": _vm.moveToAvailable
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left text-2xl text-gray-500"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col w-full col-md-student"
  }, [_c('p', {
    staticClass: "text-base text-black"
  }, [_vm._v(_vm._s(_vm.inviteColumnName))]), _vm._v(" "), (!_vm.remove_student_mode) ? _c('div', {
    staticClass: "w-full h-80 max-h-80 p-3 border border-gray-100 rounded overflow-y-auto"
  }, [_c('div', {
    staticClass: "mb-2 bg-white border rounded border-gray-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_string_invited),
      expression: "search_string_invited"
    }],
    staticClass: "p-2 text-sm placeholder-gray-200 w-full text-gray-500 bg-input",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search_string_invited)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_string_invited = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.can_be_removed.length) ? _c('div', {
    staticClass: "flex flex-nowrap"
  }, [_c('pl-checkbox', {
    attrs: {
      "disabled": _vm.remove_student_mode
    },
    on: {
      "change": function($event) {
        return _vm.handleSelectAllInvited($event)
      }
    },
    model: {
      value: (_vm.is_all_selected_invited),
      callback: function($$v) {
        _vm.is_all_selected_invited = $$v
      },
      expression: "is_all_selected_invited"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n                  " + _vm._s(_vm.is_all_selected_invited ? 'De-select All' : 'Select All') + "\n                ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.sorted_invited_list), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "flex flex-nowrap my-2"
    }, [_c('pl-checkbox', {
      attrs: {
        "disabled": _vm.remove_student_mode
      },
      on: {
        "change": function($event) {
          return _vm.handleSelectStudentUninvite(
            $event,
            user.id || user.userId
          )
        }
      },
      model: {
        value: (_vm.sorted_invited_list[index].selected),
        callback: function($$v) {
          _vm.$set(_vm.sorted_invited_list[index], "selected", $$v)
        },
        expression: "sorted_invited_list[index].selected"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text-gray-500"
    }, [_vm._v("\n                  " + _vm._s(user.name || user.profile.name.fullName) + "\n                ")])], 1)
  })], 2) : _vm._e()])])]]], 2), _vm._v(" "), (_vm.show_disconnect_integration_modal) ? _c('DisconnectAssignmentModal', {
    attrs: {
      "integrationToDisconnect": _vm.integration_connected
    },
    on: {
      "close": function($event) {
        _vm.show_disconnect_integration_modal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-gray-500 leading-5 w-11/12"
  }, [_c('p', [_vm._v("\n          You can only connect the RoundTable to one LMS assignment at a time.\n        ")]), _vm._v(" "), _c('p', [_vm._v("To change LMS assingment you need to disconnect this one.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "cursor-pointer",
    attrs: {
      "data-toggle": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-alt text-gray-400"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-342454e5!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/integrationsAssignmentModal.vue
// module id = 1000
// module chunks = 61